export const AUTHORIZATION_CONTACT_URL = '/authorization/proxy/Authorization';
export const GET_CONTACT_URL = `${AUTHORIZATION_CONTACT_URL}/GetContactViewModel`;
